export default "__VITE_ASSET__DhnbTY0K__"